import React, { useState, useEffect } from "react";
import { PlayerContainer, PostContainer, Content } from "./Shared";
import Player from "react-player";
import { MUSIC_PLAYER_TYPES } from "posts/constants";
import PostFooter from "../PostFooter/PostFooter";

export default function MusicPost(props) {
  const [playing, setPlaying] = useState(false);
  const renderPostFooter = () =>
    props.activeAudience || props.showPostFooter ? (
      <PostFooter {...props} />
    ) : null;

  useEffect(
    function mount() {
      function onScroll() {
        setPlaying(false);
      }

      window.addEventListener("scroll", onScroll);

      return function unMount() {
        window.removeEventListener("scroll", onScroll);
      };
    },
    [playing, setPlaying]
  );

  const renderPlayer = () => {
    switch (props.player) {
      case MUSIC_PLAYER_TYPES.SPOTIFY: {
        return (
          <iframe
            src={props.url}
            width="100%"
            height="380"
            frameBorder="0"
            allowtransparency="true"
            allow="encrypted-media"
          />
        );
      }
      default:
        {
        }
        return (
          <PlayerContainer>
            <Player
              controls={true}
              url={props.url}
              playing={playing}
              width="100%"
              onPlay={() => {
                setPlaying(true);
              }}
              onPause={() => {
                setPlaying(false);
              }}
              onEnded={() => {
                setPlaying(false);
              }}
            />
          </PlayerContainer>
        );
    }
  };

  return (
    <PostContainer {...props}>
      <Content noPadding>{renderPlayer()}</Content>
      {renderPostFooter()}
    </PostContainer>
  );
}
